const PeriodDuration = {
    custom : 0,
    day : -1,
    week : -7,
    month : -30,
    year : -365,
    all : -3650
}

export default PeriodDuration;